import { useContext } from "react";
import { useOptionalProviderAttachments } from "./useOptionalProviderAttachments";
import { LocalAttachmentsContext } from "./LocalAttachmentsContext";

/**
 * `usePromptInputAttachments` for components that may render outside any
 * `PromptInput` / `PromptInputProvider` (e.g. a chat panel without file
 * upload). Returns `null` instead of throwing so the caller can hide or
 * disable its attach affordance.
 */
export const useOptionalPromptInputAttachments = () => {
  const provider = useOptionalProviderAttachments();
  const local = useContext(LocalAttachmentsContext);
  return provider ?? local;
};
